var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / AR") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-AR",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#F5F5F5",
    strokeWidth: 0.5,
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 19.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#88BBE8",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 6.66666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#88BBE8",
    mask: "url(#mask-2)",
    x: 0,
    y: 13.3333333,
    width: 28,
    height: 6.66666667
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-1",
    stroke: "#DB7A2C",
    strokeWidth: 0.666666667,
    fill: "#F4B32E",
    mask: "url(#mask-2)",
    cx: 14,
    cy: 10,
    r: 2.33333333
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAr);
export default __webpack_public_path__ + "static/media/AR.2f3d1411ae3cbc66d66385789c3e6f0d.svg";
export { ForwardRef as ReactComponent };